import { Tooltip } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
export const LightTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: 13,
  },
}))(Tooltip);
